module.exports = __webpack_public_path__ + "img/banner-bg_5.53d314ef.png";